import { Dropdown } from 'primereact/dropdown'
import React, { useEffect, useState } from 'react'
import infoIcon from '../../assets/images/infoBlue.svg'
import trashIcon from '../../assets/images/trash.svg'
import deleteIcon from '../../assets/images/delete_icon_red.png'
import {
	FORM_FIELDS,
	ULD_FORM_FIELDS,
	WEIGHT_UNIT_SELECT_ITEMS,
	WEIGHT_UNIT_SELECT_ITEMS_WO_TON,
	ULD_TYPES_WITH_CONTOUR,
} from '../../constants'
import { getPivotWeight, getULDTypeByCode } from '../../services/searchPanelServices'
import ULDTypeAutocomplete from '../ULDTypeAutocomplete'
import './item-form.scss'
import { allowNumberOnly } from '../../utils/common'
import { useTranslation } from 'react-i18next'
import Messages from '../../constants/Messages'
import CommonInput from '../../common/Resusable/CommonInput'
import { CommonDropDown } from '../../common/Resusable/CommonDropDown'
const ULDLineItem = ({
	item,
	index,
	selectedOrigin,
	handleItemChange,
	error,
	clearItemError,
	ULDDetails,
	calculateTotalWeight,
	weightUnit,
	handleRemoveItem,
	setWeightUnit,
	removedRowCount,
	captureAWB,
	captureAwb,
	draftCallback,
	setNotificationMessage,
	setNotificationType,
	excludeTon,
	hideUldNoOfPieces,
	isDisabled = false,
}) => {
	const normalizeContour = (val) => {
		const v = (val || '').toString().trim().toUpperCase();
		if (v === 'LD' || v === 'L7') return 'LD';
		if (v === 'MD' || v === 'Q6') return 'MD';
		return val;
	};

	const [uldType, setUldType] = useState(item.uldType)
	const [pieces, setPieces] = useState(item.pieces)
	const [contour, setContour] = useState(normalizeContour(item.contour))
	const [weight, setWeight] = useState(item.weight)
	const [uldVolume, setUldVolume] = useState(item.uldVolume)
	const [pivotWeight, setPivotWeight] = useState(item.pivotWeight)

	//For multilingual translation
	const { t: baseT, i18n } = useTranslation(['labels', 'errors'])
	const captureLabelT = i18n.getFixedT('en', 'labels')
	const captureErrorT = captureAwb ? i18n.getFixedT('en', 'errors') : null
	const t = (key, options) =>
		options?.ns === 'errors' && captureErrorT
			? captureErrorT(key, options)
			: baseT(key, options)

	const getLabel = (commonKey, captureKey = commonKey) => {
		if (captureAwb) {
			return captureLabelT([
				`CAPTURE_AWB.${captureKey}`,
				`COMMON.${commonKey}`,
				`BOOKING.${commonKey}`,
				`PERMANENT_BOOKING.${commonKey}`,
				`EXCEL.${commonKey}`,
			])
		}
		return t([
			`COMMON.${commonKey}`,
			`BOOKING.${commonKey}`,
			`PERMANENT_BOOKING.${commonKey}`,
			`EXCEL.${commonKey}`,
		])
	}

	const CONTOUR_ITEMS = [
		{ label: getLabel('MAIN_DECK'), value: 'MD' },
		{ label: getLabel('LOWER_DECK'), value: 'LD' },
	]

	useEffect(() => {
		setUldType(item.uldType)
		setPieces(item.pieces)
		setContour(normalizeContour(item.contour))
		setWeight(item.weight)
		setUldVolume(item.uldVolume)
		setPivotWeight(item.pivotWeight)
	}, [removedRowCount])


	useEffect(() => {
		; (() => {
			setPivotWeight(null)
			if (uldType && selectedOrigin && selectedOrigin.code) {
				if (ULD_TYPES_WITH_CONTOUR.includes(uldType) && !contour) {
					return
				}
				getPivotWeight(selectedOrigin.code, uldType, contour)
					.then((res) => {
						if (res && res.pivotweight) {
							setPivotWeight(res.pivotweight)
						}
					})
					.catch((err) => {
						console.log(err)
					})

			}
		})()
	}, [uldType, contour, selectedOrigin])


	useEffect(() => {
		handleItemChange(index, {
			uldType,
			contour,
			pieces,
			weight,
			pivotWeight,
			uldVolume,
		})
	}, [uldType, contour, pieces, weight, pivotWeight, uldVolume])


	useEffect(() => {
		setContour(normalizeContour(item.contour))
	}, [uldType])

	useEffect(() => {
		if (uldType && ULD_TYPES_WITH_CONTOUR.includes(uldType)
			&& contour) {
			; (() => {
				getULDTypeByCode(uldType)
					.then((selectedUldType) => {
						if (selectedUldType && selectedUldType.uldtypcod) {
							contour === 'LD'
								? setUldVolume(selectedUldType.maxvolld)
								: setUldVolume(selectedUldType.maxvolmd)
						}
					})
					.catch((err) => {
						console.log(err)
					})

			})()
		}
	}, [contour])

	const uldTypeError =
		error &&
			error[FORM_FIELDS.ULD_ITEMS] &&
			error[FORM_FIELDS.ULD_ITEMS][index] &&
			error[FORM_FIELDS.ULD_ITEMS][index][ULD_FORM_FIELDS.ULD_TYPE]
			? error[FORM_FIELDS.ULD_ITEMS][index][ULD_FORM_FIELDS.ULD_TYPE]
			: null
	const contourError =
		error &&
			error[FORM_FIELDS.ULD_ITEMS] &&
			error[FORM_FIELDS.ULD_ITEMS][index] &&
			error[FORM_FIELDS.ULD_ITEMS][index][ULD_FORM_FIELDS.CONTOUR]
			? error[FORM_FIELDS.ULD_ITEMS][index][ULD_FORM_FIELDS.CONTOUR]
			: null
	const piecesError =
		error &&
			error[FORM_FIELDS.ULD_ITEMS] &&
			error[FORM_FIELDS.ULD_ITEMS][index] &&
			error[FORM_FIELDS.ULD_ITEMS][index][ULD_FORM_FIELDS.PIECES]
			? error[FORM_FIELDS.ULD_ITEMS][index][ULD_FORM_FIELDS.PIECES]
			: null
	const weightError =
		error &&
			error[FORM_FIELDS.ULD_ITEMS] &&
			error[FORM_FIELDS.ULD_ITEMS][index] &&
			error[FORM_FIELDS.ULD_ITEMS][index][ULD_FORM_FIELDS.WEIGHT]
			? error[FORM_FIELDS.ULD_ITEMS][index][ULD_FORM_FIELDS.WEIGHT]
			: null

	return (
		<div
			className={`cargo-uld-form ${index > 0 ? 'neg-margin' : ''} ${ULDDetails.length - 1 === index ? 'last-item' : ''
				}`}
			key={index}
		>
			<div className='top-section'>
				<div
					className={`form-group common-autocomplete ${uldTypeError ? 'red-border' : ''} ${uldType ? 'p-filled' : ''}`}
				>
					<div className='p-float-label'>
						<ULDTypeAutocomplete
							inputId={`uld-type-${index}`}
							className={'form-control autocomplete'}
							selectedUldType={{ code: uldType }}
							setSelectedUldType={(uldTypeObj) => {
								if (uldTypeObj && uldTypeObj.uldtypcod) {
									setUldType(uldTypeObj.uldtypcod);
									setUldVolume(uldTypeObj.maxvol);
								} else {
									setUldType(null);
									setUldVolume(null);
								}
							}}
							clearError={() => clearItemError(ULD_FORM_FIELDS.ULD_TYPE, index)}
							setNotificationMessage={setNotificationMessage}
							setNotificationType={setNotificationType}
							onFocusHandler={() => setFocused(true)}
							onBlurHandler={() => setFocused(false)}
							disabled={isDisabled}
						/>
						<label htmlFor={`uld-type-${index}`} className="additional-style">
							{getLabel('ULD_TYPE')}
						</label>
					</div>
					<span className="search-panel__errormsg">
						{uldTypeError ? t(uldTypeError, { ns: 'errors' }) : ''}
					</span>
				</div>

				{ULD_TYPES_WITH_CONTOUR.includes(uldType) ? (
					<CommonDropDown
						className={'contor-section'}
						label={getLabel('CONTOUR')}
						error={contourError ? t(contourError, { ns: 'errors' }) : ''}
						value={contour}
						options={CONTOUR_ITEMS}
						onChange={(e) => setContour(e.target.value)}
						onFocus={() => clearItemError(ULD_FORM_FIELDS.CONTOUR, index)}
						disabled={isDisabled}
					/>


				) : (
					<></>
				)}
				{!hideUldNoOfPieces && <div
					className={`form-group`}
				>
					<CommonInput
						type="text"
						label={getLabel('NO_OF_UNITS')}
						className="form-control"
						disabled={isDisabled}
						value={pieces}
						onChange={(e) => {
							if (e.target.value.length <= 9) {
								setPieces(e.target.value);
							}
						}}
						onFocus={() => clearItemError(ULD_FORM_FIELDS.PIECES, index)}
						inputId={`pieces-${index}`}
						error={piecesError ? t(piecesError, { ns: 'errors' }) : ''}
					/>

				</div>}
				{!captureAWB && (
					<div className={`form-group input-with-dropdown`}>
						<CommonInput
							id={`weight-${index}`}
							label={getLabel('WT_PER_UNIT')}
							type='text'
							className=''
							disabled={isDisabled}
							value={weight}
							onKeyDown={(evt) => allowNumberOnly(evt)}
							onChange={(e) => {
								const value = e.target.value.replace(/[^0-9.]/g, '');
								if (
									value.length <= 9 &&
									(!value.split('.')[1] ||
										!value.split('.')[1].length ||
										value.split('.')[1].length < 2) &&
									value.split('.').length <= 2
								) {
									setWeight(value);
								}
							}}
							onBlur={() => {
								if (!Number(weight)) {
									setWeight(null);
								} else {
									calculateTotalWeight();
								}
							}}
							onFocus={() => clearItemError(ULD_FORM_FIELDS.WEIGHT, index)}
							error={weightError ? t(weightError, { ns: 'errors' }) : ''}
						// disabled={index ? true : false}
						/>
						<CommonDropDown
							id={`weight-${index}-dropdown`}
							value={weightUnit}
							options={excludeTon ? WEIGHT_UNIT_SELECT_ITEMS_WO_TON : WEIGHT_UNIT_SELECT_ITEMS}
							onChange={(e) => {
								setWeightUnit(e.target.value);
								if (draftCallback) {
									draftCallback(true);
								}
							}}
							disabled={isDisabled || index ? true : false}
							error={weightError}
							isNoLabel
						/>
					</div>

				)}
			</div>
			<div className='d-flex w-100'>
				{uldType && pivotWeight ? (
					<div className='uld-form-message'>
						<img className='info-icon' src={infoIcon} />
						<div className='info-message'>
							{t(Messages.PIVOT_WT_INFO_MSG, {
								weight: pivotWeight,
								ns: 'errors',
							})}
						</div>
					</div>
				) : (
					<></>
				)}
				{ULDDetails.length > 1 ? (
					<div class='delete-section' onClick={!isDisabled ? () => handleRemoveItem(index) : undefined}>
						<img
							src={deleteIcon}
							alt='Trash'
							title='Trash'
						/>
						<span>{getLabel('DELETE')}</span>
					</div>
				) : (
					<></>
				)}
			</div>
		</div>
	)
}

export default ULDLineItem
